module.exports = __webpack_public_path__ + "img/nicetohave-product-design-04.d422fdac.jpg";